import BaseValidator from '@/app-core/lib/data/validator/BaseValidator'
import ValidatorTypesEnum from '@/app-core/lib/data/validator/ValidatorTypesEnum'
import {isValidMobilePhone} from '@/app-core/api/validations/CustomValidator'

export default class RegisterValidator extends BaseValidator {
  validatorRules = {
    Firstname: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 2,
      maxLen  : 32
    },
    Lastname: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 2,
      maxLen  : 32
    },
    Email: {
      required: true,
      type    : ValidatorTypesEnum.Email,
      maxLen  : 96
    },
    Phone: {
      required   : true,
      type       : ValidatorTypesEnum.String,
      mobilePhone: isValidMobilePhone
    },
    Password: {
      requiredIf: ['FromSocialProvider', false],
      type      : ValidatorTypesEnum.String,
      minLen    : 8
    },
    PasswordConfirm: {
      requiredIf: ['FromSocialProvider', false],
      type      : ValidatorTypesEnum.String,
      equals    : 'Password',
      minLen    : 8
    },
    TermsCondition: {
      required: true,
      type    : ValidatorTypesEnum.Boolean
    },
    MarketingConsent: {
      required: false,
      type    : ValidatorTypesEnum.Boolean
    }
  }

  validatorMessages = {
    el: {
      mobilePhone: 'Πρέπει να είναι έγκυρος αριθμός κινητού τηλεφώνου'
    },
    en: {
      mobilePhone: 'Must be a valid mobile number'
    }
  }

  constructor(data = {}) {
    super(data)
  }
}
